import React from "react";
import { Card } from "react-bootstrap";

export const infoCardComponent = ({
  title,
  content,
  style,
  key,
}: {
  title?: string;
  content: React.ReactNode;
  style?: React.CSSProperties;
  key?: string | number;
}) => {
  return (
    <Card className="m-1" style={style ?? {}} key={key}>
      <Card.Body>
        {title ? (
          <Card.Title role="heading" aria-level={5}>
            {title}
          </Card.Title>
        ) : null}
        {content}
      </Card.Body>
    </Card>
  );
};
